(function ($) {
    // Ricava automaticamente l'URL di admin-ajax.php
    function getAjaxUrl() {
        // prova ad usare lo stesso origin della pagina
        var origin = window.location.origin || (window.location.protocol + '//' + window.location.host);
        return origin + '/wp-admin/admin-ajax.php';
    }

    var AJAX_URL = getAjaxUrl();
    var $grid    = $('#news-grid');
    var $loadWrap= $('.news-loadmore-wrap');
    var $loadBtn = $('#news-loadmore');
    var perPage  = parseInt($grid.data('offset'), 10) || 9; // offset iniziale = perPage
    var catId    = parseInt($grid.data('cat') || 0, 10);

    var selectedClients = [];
    var selectedYears   = [];
    var offset          = perPage;

    function collectFilters() {
        selectedClients = $('.filter[data-filter="cliente"] input[type="checkbox"]:checked')
            .map(function(_, el){ return parseInt(el.value, 10); })
            .get();

        selectedYears = $('.filter[data-filter="anno"] input[type="checkbox"]:checked')
            .map(function(_, el){ return parseInt(el.value, 10); })
            .get();
    }

    function toggleLoadMore(show) {
        if (show) $loadWrap.show(); else $loadWrap.hide();
    }

    function requestNews(append) {
        var payload = {
            action:  'ma_fetch_news',
            perPage: perPage,
            offset:  append ? offset : 0,
            clienti: selectedClients,
            anni:    selectedYears,
            catId:   catId
        };

        if ($loadBtn.length) $loadBtn.prop('disabled', true).text('Loading...');

        return $.post(AJAX_URL, payload).done(function (res) {
            if (!res || !res.success) return;

            var itemsHtml = res.data.itemsHtml || '';
            var hasMore   = !!res.data.hasMore;
            var nextOffset= parseInt(res.data.nextOffset || 0, 10);

            if (append) {
                $grid.append(itemsHtml);
                offset = nextOffset;
            } else {
                $grid.html(itemsHtml);
                offset = perPage;
            }

            toggleLoadMore(hasMore);
        }).always(function () {
            if ($loadBtn.length) $loadBtn.prop('disabled', false).text('MOSTRA PIÙ NOTIZIE');
        });
    }





    // --- DROPDOWNS estetici con apertura/chiusura esclusiva ---
    var $filters = $('.filter.dropdown');
    var $toggles = $filters.find('.filter-toggle');

    function openPanel($btn){
        var $panel = $btn.next('.filter-panel');
        // chiudi tutti gli altri
        $toggles.not($btn).each(function(){
            var $b = $(this);
            $b.attr('aria-expanded','false');
            $b.next('.filter-panel').attr('data-open','false').prop('hidden', true);
        });
        // apri questo
        $btn.attr('aria-expanded','true');
        $panel.prop('hidden', false).attr('data-open','true');
    }

    function closePanel($btn){
        var $panel = $btn.next('.filter-panel');
        $btn.attr('aria-expanded','false');
        $panel.attr('data-open','false');
        setTimeout(function(){ $panel.prop('hidden', true); }, 160); // match animazione CSS
    }

    function closeAllPanels(){
        $toggles.each(function(){ closePanel($(this)); });
    }

    // click su toggle
    $toggles.off('click').on('click', function(e){
        e.preventDefault();
        var $btn = $(this);
        var isOpen = $btn.attr('aria-expanded') === 'true';
        if (isOpen) { closePanel($btn); } else { openPanel($btn); }
    });

    // click su reset: chiudi tutto
    $('.filters-reset').on('click', function(){ closeAllPanels(); });

    // click fuori: chiudi tutto
    $(document).on('click', function(e){
        var $t = $(e.target);
        if ( $t.closest('.filter.dropdown').length === 0 && $t.closest('.filters-reset').length === 0 ){
            closeAllPanels();
        }
    });

    // ESC: chiudi tutto
    $(document).on('keydown', function(e){
        if (e.key === 'Escape') closeAllPanels();
    });

    // --- stato visivo "attivo" dei filtri se ci sono checkbox selezionati ---
    function updateFilterActiveState() {
        $('.filter.dropdown').each(function () {
            var $filter = $(this);
            var hasChecked = $filter.find('input[type="checkbox"]:checked').length > 0;
            $filter.toggleClass('active', hasChecked);
        });
    }

    // aggiorna quando si cambia qualcosa nei checkbox
    $(document).on('change', '.filter.dropdown input[type="checkbox"]', updateFilterActiveState);

    // aggiorna anche al load iniziale (es. se i filtri restano spuntati da refresh)
    $(window).on('load', updateFilterActiveState);

    // opzionale: aggiorna quando fai reset (chiudi tutti e togli attivi)
    $('.filters-reset').on('click', function () {
        $('.filter.dropdown').removeClass('active');
    });


    // Filtri → refresh
    $('.filter input[type="checkbox"]').on('change', function () {
        collectFilters();
        requestNews(false);
    });

    // Load more
    $loadBtn.on('click', function () {
        collectFilters();
        requestNews(true);
    });

    // Reset
    $('.filters-reset').on('click', function () {
        $('.filter input[type="checkbox"]').prop('checked', false);
        collectFilters();
        requestNews(false);
    });

})(jQuery);
